module.exports = `${require.publicPath}app.a43e6576.png`;